import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = ({ contactUs }: { contactUs: () => void }) => {
	const faqs = [
		{
			icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M22 20.9999V18.9999C21.9993 18.1136 21.7044 17.2527 21.1614 16.5522C20.6184 15.8517 19.8581 15.3515 19 15.1299" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
			),
			question: "How does Talentick.ai improve candidate assessment accuracy?",
			answer:
				"Our platform uses AI algorithms to evaluate skills and experience objectively, eliminating biases and enhancing precision.",
		},
		// {
		// 	icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		// 		<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		// 		<path d="M12 6V12L16 14" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		// 	</svg>
		// 	),
		// 	question: "Can Talentick.ai integrate with our existing HR tools?",
		// 	answer:
		// 		"Yes, Talentick.ai seamlessly integrates with popular ATS and HRM platforms for streamlined hiring.",
		// },
		{
			icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M16 20V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V20" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M20 6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
			),
			question: "What kind of assessments are auto-generated?",
			answer:
				"We provide skill-based, role-specific assessments that align with industry standards, ensuring you find the right fit every time.",
		},
		{
			icon: (<svg width="20" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M15 19V17C15 15.9391 14.5786 14.9217 13.8284 14.1716C13.0783 13.4214 12.0609 13 11 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8 9C10.2091 9 12 7.20914 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.20914 5.79086 9 8 9Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</svg>

			),
			question: "How is AI used to screen resumes?",
			answer:
				"Talentick.ai uses advanced AI to scan resumes for relevant skills and experience, ranking candidates against job requirements for quick shortlisting.",
		},
		{
			icon: (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M18.25 12.75C18.25 13.2362 18.0568 13.7025 17.713 14.0464C17.3692 14.3902 16.9029 14.5833 16.4167 14.5833H5.41667L1.75 18.25V3.58333C1.75 3.0971 1.94315 2.63079 2.28697 2.28697C2.63079 1.94315 3.0971 1.75 3.58333 1.75H16.4167C16.9029 1.75 17.3692 1.94315 17.713 2.28697C18.0568 2.63079 18.25 3.0971 18.25 3.58333V12.75Z" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
			</svg>

			),
			question: "Is it suitable for large-scale hiring?",
			answer:
				"Absolutely, Talentick.ai is designed to handle high-volume recruitment efficiently, making it ideal for both startups and large enterprises.",
		},
	];
	return (
		<>
			<div className="text-left md:text-center md:px-4 mt-32 "> {/* Reduced bottom margin from default */}
				<h2 className="text-4xl md:text-5xl font-semibold text-gray-800 mb-2 leading-normal md:leading-relaxed md:text-center ">Frequently Asked Questions</h2>
				<p className="mt-6 text-lg"> {/* Reduced top margin from mt-4 to mt-2 */}
					These are the most commonly asked questions about talentick.ai. <br />
					Can’t find what you’re looking for?{" "}
					<span className="text-gray-600 underline cursor-pointer" onClick={contactUs}>
						Get in touch with our team!
					</span>
				</p>
			</div>

			<div className="flex justify-center px-4 mt-5 ">
				<div className="w-full max-w-4xl space-y-1 ">
					{faqs.map((elem, index) => (
						<Accordion key={index} type="single" collapsible>
							<AccordionItem value={`item-${index}`}>
								<AccordionTrigger className="text-lg md:text-center text-left">
									<div className="flex items-center gap-4 ">
										<div className="bg-white border-2 border-[#D9D9D9] p-2.5 rounded-xl">
											{elem.icon}
										</div>
										<span>{elem.question}</span>
									</div>
								</AccordionTrigger>
								<AccordionContent className="text-lg text-gray-600 mt-2">
									{elem.answer}
								</AccordionContent>
							</AccordionItem>
						</Accordion>
					))}
				</div>
			</div>
		</>

	);
};

export default FAQ;
